<template>
  <div class="number-input">
    <button class="number-input__button number-input__decrement"
      @click="decrement" 
      :disabled="value === min" />
    <span class="number-input__value">{{ value }}</span>
    <button class="number-input__button number-input__increment"
      @click="increment"
      :disabled="value === max"
      >+</button>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    value: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      required: false,
      default: () => 0,
    },
    max: {
      type: Number,
      required: false,
      default: () => 9999999,
    },
  },
})
export default class NumberInput extends Vue {
  decrement () {
    if (this.value > this.min) {
      this.$emit('input', this.value - 1)
    }
  }

  increment () {
    if (this.value < this.max) {
      this.$emit('input', this.value + 1)
    }
  }
}
</script>

<style lang="scss">

.number-input {
  color: #005CAA;
  display: flex;
  background-color: #EEEEEE;
  padding: 8px 0;
  font-size: 28px;

  &__button {
    flex: 1 0 auto;
    border: 0;
    background-color: transparent;
    padding: 0 15px;
    outline: none;

    &:hover {
      color: #009FEA;
      cursor: pointer;

      &::before {
        @include media(tablet) {
          background-color: #009FEA;
        }
      }
    }

    &:disabled {
      opacity: 0;
      cursor: auto;
    }
  }
  
  &__value {
    flex: 0 1 auto;
    width: 58px;
    text-align: center;
    font-family: 'Gotham';
    font-weight: bold;
  }

  &__increment {
    @include media(tablet) {
      font-size: 40px;
      line-height: 0;
    }
  }

  &__decrement::before {
    content: '-';

    @include media(tablet) {
      content: '';
      width: 21px;
      height: 3px;
      background-color: #005CAA;
      float: right;
      margin-left: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NumberInput.vue